import React from "react";
import { BsArrowUpShort } from "react-icons/bs";
import { AiFillEdit, AiFillDelete, AiFillEye } from "react-icons/ai";
import { isEmpty } from "lodash";

const DynamicTable = ({
  data,
  columns,
  sort,
  setSort,
  actions,
  page,
  manager,
  userRole,
  onStatusChange,
  onDelete,
}) => {
  console.log("columns", columns);
  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-2">#</th>
              {columns.map((col) => (
                <th
                  key={col.key}
                  scope="col"
                  className={`py-3 px-2 ${col.sortable ? "cursor-pointer" : ""}`}
                  onClick={() => {
                    if (col.sortable) {
                      if (sort.sort_key === col.key && sort.sort_type === "asc") {
                        setSort({ sort_key: col.key, sort_type: "desc" });
                      } else {
                        setSort({ sort_key: col.key, sort_type: "asc" });
                      }
                    }
                  }}
                >
                  <div className="flex">
                    <span>{col.label}</span>
                    {col.sortable && (
                      <span>
                        {sort.sort_key === col.key && sort.sort_type === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                        {sort.sort_key === col.key && sort.sort_type === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
              {actions && (
                <th scope="col" className="py-3 px-2 text-center">Actions</th>
              )}
            </tr>
          </thead>
          <tbody>
            {data && data.map((item, i) => (
              <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th scope="row" className="py-2 px-2 border-r font-medium text-gray-900 dark:text-white">
                  {i + 1 + 10 * (page - 1)}
                </th>
                {columns.map((col) => (
                  <td key={col.key} className="py-2 px-2 border-r">
                    {col.render ? col.render(item[col.key], item) : item[col.key]}
                  </td>
                ))}
                {actions && (
                  <td className="py-2 px-2 border-l">
                    <div className="flex justify-center gap-2">
                      {actions.view && (
                        <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" title="View" />
                      )}
                      {actions.edit && (
                        <AiFillEdit
                          className="cursor-pointer w-5 h-5 text-slate-600 ml-2"
                          title="Edit"
                          onClick={() => actions.onEdit(item)} // Add onClick handler
                        />
                      )}
                      {actions.delete && (
                        <AiFillDelete
                        className="w-5 h-5 text-red-600 ml-2"
                        title="Delete"
                        onClick={() => actions.onDelete(item)} // Add onClick handler
                        // onClick={() => actions.onEdit(item)} // Add onClick handler
                      />
                      
                    //   <li onClick={() => onDelete(item)} className="px-2 hover:bg-white hover:text-LightBlue">
                    //       <AiFillDelete className="w-5 h-5 text-red-600" title="Delete" />
                    //     </li>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
            {isEmpty(data) && (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2" colSpan={columns.length + (actions ? 1 : 0)}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DynamicTable;